import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomePage from "../views/HomePage.vue";

// Define routes
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
    meta: {
      title: "Temporal - Live Intentionally",
    },
  },
  {
    path: "/verify-email",
    name: "VerifyEmail",
    component: () => import("../views/VerifyEmail.vue"),
    meta: {
      title: "Verify Email - Temporal",
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
    meta: {
      title: "Reset Password - Temporal",
    },
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    // Lazy-load the component
    component: () => import("../views/PrivacyPolicy.vue"),
    meta: {
      title: "Privacy Policy - Temporal",
    },
  },
  {
    path: "/terms-of-service",
    name: "TermsOfService",
    // Lazy-load the component
    component: () => import("../views/TermsOfService.vue"),
    meta: {
      title: "Terms of Service - Temporal",
    },
  },
  {
    // Catch all 404 - define at the very end
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/PageNotFound.vue"),
    meta: {
      title: "Page Not Found - Temporal",
    },
  },
];

// Create router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top when navigating to a new page
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Navigation guard for setting page title
router.beforeEach((to, from, next) => {
  // Set the page title
  document.title = (to.meta.title as string) || "Temporal";

  // Future analytics tracking could be added here

  next();
});

export default router;
